import angular from 'angular';

// ES6 modules are strict by default
const newspapersServices = angular.module('applicationModule.newspapersServices', []);

const checkFiles = function (file) {
    'use strict';
    const files = [];
    const names = [];
    if (angular.isDefined(file)) {
        files.push(file);
        names.push('file');
    }

    return {files: files, names: names};
};

newspapersServices.factory('Newspaper', ['NewspaperAPI', function (NewspaperAPI) {
    'use strict';
    return {
        getList: function (appId, params) {
            return NewspaperAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        remove: function (newspaperId) {
            return NewspaperAPI.remove(newspaperId);
        },
        get: function (newspaperId, appId) {
            return NewspaperAPI.get(newspaperId, appId);
        },
        save: function (data, editMode) {
            return NewspaperAPI.save(data, editMode);
        },
        search: function (appId, search) {
            return NewspaperAPI.search(appId, search);
        },
        searchPromotions: function (appId, search) {
            return NewspaperAPI.searchPromotions(appId, search);
        },
        copy: function (newspaperId) {
            return NewspaperAPI.copy(newspaperId);
        },
        import: function (appId, newspaperId, mutationId) {
            return NewspaperAPI.import(appId, newspaperId, mutationId);
        },
        bulkDelete: function (ids) {
            return NewspaperAPI.bulkDelete(ids);
        },
        getPackageId: function (appId) {
            return NewspaperAPI.getPackageId(appId);
        }
    };
}]);

newspapersServices.service('NewspaperAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/newspapers/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {app_id: appId})});
    };

    this.remove = function (newspaperId) {
        return $http.delete(API_URL + newspaperId);
    };

    this.get = function (newspaperId, appId) {
        return $http.get(API_URL + newspaperId, {params: {app_id: appId}});
    };

    this.save = function (data, editMode) {
        if (editMode) {
            return $http.put(API_URL + data.id, data);
        } else {
            return $http.post(API_URL, data);
        }
    };

    this.search = function (appId, search) {
        return $http.get(API_URL + appId + '/types', {params: {search: search}});
    };

    this.searchPromotions = function (appId, search) {
        return $http.get(API_URL + appId + '/promotions', {params: {search: search}});
    };

    this.copy = function (newspaperId) {
        return $http.get(API_URL + 'copy/' + newspaperId);
    };

    this.import = function (appId, newspaperId, mutationId) {
        return $http.get(API_URL + appId + '/import/' + newspaperId + '/' + mutationId);
    };

    this.bulkDelete = function (ids) {
        return $http.post(API_URL + 'bulk/action/delete', {ids: ids});
    };

    this.getPackageId = function (appId) {
        return $http.get(API_URL + appId + '/package-id');
    };
}]);

newspapersServices.factory('NewspaperPage', ['NewspaperPageAPI', function (NewspaperPageAPI) {
    'use strict';
    return {
        getList: function (appId, newspaperId, params) {
            return NewspaperPageAPI.getList(appId, newspaperId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        remove: function (newspaperPageId) {
            return NewspaperPageAPI.remove(newspaperPageId);
        },
        get: function (newspaperPageId) {
            return NewspaperPageAPI.get(newspaperPageId);
        },
        save: function (data, file, editMode) {
            return NewspaperPageAPI.save(data, file, editMode);
        },
        searchRecipes: function (appId, search) {
            return NewspaperPageAPI.searchRecipes(appId, search);
        },
        searchProducts: function (appId, promotionId) {
            return NewspaperPageAPI.searchProducts(appId, promotionId);
        },
        changeOrder: function (data) {
            return NewspaperPageAPI.changeOrder(data);
        },
        importProducts: function (appId, newspaperId, file) {
            return NewspaperPageAPI.importProducts(appId, newspaperId, file);
        },
        importShops: function (appId, newspaperId, file) {
            return NewspaperPageAPI.importShops(appId, newspaperId, file);
        }
    };
}]);

newspapersServices.service('NewspaperPageAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/newspaper-page/';

    this.getList = function (appId, newspaperId, params) {
        return $http.get(API_URL, {
            params: angular.extend(AppsoupAPI.getTableParams(params), {
                app_id: appId,
                newspaper_id: newspaperId
            })
        });
    };

    this.remove = function (newspaperPageId) {
        return $http.delete(API_URL + newspaperPageId);
    };

    this.get = function (newspaperPageId) {
        return $http.get(API_URL + newspaperPageId);
    };

    this.save = function (data, file, editMode) {
        const files = checkFiles(file);

        if (editMode) {
            if (angular.isDefined(file)) {
                const newFields = angular.extend(data, {_method: 'PUT'});

                return Upload.upload({
                    url: API_URL + data.id,
                    method: 'POST',
                    sendObjectsAsJsonBlob: false,
                    fields: newFields,
                    file: files.files,
                    fileFormDataName: files.names
                });
            } else {
                return $http.put(API_URL + data.id, data);
            }
        } else {
            if (angular.isDefined(file)) {
                return Upload.upload({
                    url: API_URL,
                    method: 'POST',
                    sendObjectsAsJsonBlob: false,
                    fields: data,
                    file: files.files,
                    fileFormDataName: files.names
                });
            } else {
                return $http.post(API_URL, data);
            }
        }
    };

    this.searchRecipes = function (appId, search) {
        return $http.get(API_URL + appId + '/recipes', {params: {search: search}});
    };

    this.searchProducts = function (appId, promotionId) {
        return $http.get(API_URL + appId + '/products', {params: {promotionId: promotionId}});
    };

    this.changeOrder = function (data) {
        return $http.post(API_URL + 'change-order', data);
    };

    this.importProducts = function (appId, newspaperId, file) {
        const data = {};

        return Upload.upload({
            url: API_URL + appId + '/import/data/' + newspaperId,
            method: 'POST',
            sendObjectsAsJsonBlob: false,
            fields: data,
            file: file
        });
    };
}]);

newspapersServices.factory('NewspaperImportShops', ['NewspaperImportShopsAPI', function (NewspaperImportShopsAPI) {
    'use strict';
    return {
        getData: function (appId, newspaperId, params) {
            return NewspaperImportShopsAPI.getList(appId, newspaperId, params);
        },
        getImportShopsExampleXls: function () {
            return NewspaperImportShopsAPI.getImportShopsExampleXls();
        },
        importShops: function (appId, newspaperId, file) {
            return NewspaperImportShopsAPI.importShops(appId, newspaperId, file);
        },
        remove: function (newspaperId, shopId) {
            return NewspaperImportShopsAPI.remove(newspaperId, shopId);
        }
    };
}]);

newspapersServices.service('NewspaperImportShopsAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/newspapers/';

    this.getList = function (appId, newspaperId, params) {
        return $http.get(API_URL + appId + '/import-shops/' + newspaperId, {
            params: angular.extend(AppsoupAPI.getTableParams(params), {
                app_id: appId
            })
        });
    };

    this.getImportShopsExampleXls = function () {
        return $http.get(API_URL + 'download/example-import-shops');
    };

    this.importShops = function (appId, newspaperId, file) {
        const data = {};

        return Upload.upload({
            url: API_URL + appId + '/import-shops/' + newspaperId,
            method: 'POST',
            sendObjectsAsJsonBlob: false,
            fields: data,
            file: file
        });
    };

    this.remove = function (newspaperId, shopId) {
        return $http.delete(API_URL + 'import-shops/' + newspaperId + '/shop/' + shopId);
    };

}]);

export default newspapersServices;
